export interface CountryData {
    name: string;
    code: string;
    phone: string;
}

export interface CountryStateConfig {
    [key: string]: {
        states: string[];
        code: string;
    };
}

export const countryStateConfig: CountryStateConfig = {
    'Malaysia': {
        code: 'MY',
        states: [
            'Johor',
            'Kedah',
            'Kelantan',
            'Melaka',
            'Negeri Sembilan',
            'Pahang',
            'Penang',
            'Perak',
            'Perlis',
            'Sabah',
            'Sarawak',
            'Selangor',
            'Terengganu',
            'Kuala Lumpur',
            'Putrajaya',
            'Labuan'
        ]
    },
    'Singapore': {
        code: 'SG',
        states: ['Tampines',
                 'Tanjong Pagar',
                 'Sentosa',
                 'Ang Mo Kio',
                 'Bukit Timah',
                 'Geylang',
                 'Queenstown',
                 'Bishan',
                 'Choa Chu Kang',
                 'Little India',
                 'MacPherson',
                 'Mount Faber',
                 'Paya Lebar',
                 'River Valley',
                 'Upper East Coast',
                 'Woodlands',
                 'Clementi',
                 'District 17',
                 'Katong',
                 'Orchard',
                 'Raffles Place',
                 'Tanglin',
                 'Yishun',
                 'Bedok',
                ]
    },
    'Indonesia': {
        code: 'ID',
        states: ['Sumatra',
                 'Java',
                 'Bali',
                 'Lombok',
                 'Timor',
                 'Kalimantan',
                 'Sulawesi',
                 'Maluku Islands',
                 'Papua',
                ]
    },
    'Brunei': {
        code: 'BN',
        states: ['Brunei-Muara',
                 'Belait',
                 'Tutong',
                 'Temburong',
                ]
    }
};

export const countries: CountryData[] = [
    { name: 'Malaysia', code: 'MY', phone: '60' },
    { name: 'Indonesia', code: 'ID', phone: '62' },
    { name: 'Brunei', code: 'BN', phone: '673' },
    { name: 'Singapore', code: 'SG', phone: '65' }
].sort((a, b) => a.name.localeCompare(b.name));

export interface OptionType {
    value: string;
    label: string;
}

export const ageRanges: OptionType[] = [
    { value: 'under_6', label: '< 6 Years' },
    { value: '7_12', label: '7-12' },
    { value: '13_15', label: '13-15' },
    { value: '16_17', label: '16-17' },
    { value: '18_26', label: '18-26' },
    { value: '27_30', label: '27-30' },
    { value: '31_35', label: '31-35' },
    { value: '36_40', label: '36-40' },
    { value: '40_50', label: '40-50' },
    { value: '51_60', label: '51-60' },
    { value: 'over_60', label: '>60' }
];

export const genderOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' }
];
